export const NATIONAL_LEVEL = 0;
export const PROVINCE_LEVEL = 1;
export const REGION_LEVEL = 2;
export const BOROUGH_LEVEL = 3;
